export default "__VITE_ASSET__R$4qi4A9__"